import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var HelpFilledIcon = function HelpFilledIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "HelpFilledIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m1-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.881-5.387a.98.98 0 0 0-.648.115.9.9 0 0 0-.407.478.6.6 0 0 1-1.128-.409c.17-.47.505-.863.94-1.111a2.18 2.18 0 0 1 1.44-.256c.494.082.947.332 1.275.71.328.38.51.861.509 1.362 0 .818-.606 1.349-1.017 1.623-.172.114-.34.205-.483.273V8.5a.6.6 0 0 1-1.2 0V8a.6.6 0 0 1 .41-.569l.006-.002.035-.013q.049-.018.14-.058c.12-.053.275-.131.426-.232.34-.226.483-.444.483-.625a.87.87 0 0 0-.216-.574.96.96 0 0 0-.565-.314m1.981.888v.001h-.6z",
      clipRule: "evenodd"
    })
  }));
};

export { HelpFilledIcon };
